import { CrudService } from '@monorepo/client-common';

export default class UserActivityService extends CrudService {
  static override route = 'user-activity';
}
